import { getParams } from "./geParams";
import { log } from "./log";

const COOKIE_NAME = "_fw_track";

function getCookie(name: string) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
}

function setCookie(name: string, value: string) {
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; SameSite=Lax; Secure`;
}

export function saveParams({ debug = false }: { debug?: boolean }) {
  let currentParams = {};

  try {
    const raw = getCookie(COOKIE_NAME);
    if (raw) currentParams = JSON.parse(raw);
  } catch (e) {
    currentParams = {};
  }

  const params = getParams();

  const paramsToSave = {
    ...currentParams,
    ...params,
  };

  setCookie(COOKIE_NAME, JSON.stringify(paramsToSave));

  log({
    debug,
    message: "Parâmetros salvos",
    data: {
      params,
      paramsToSave,
    },
  });
}
